/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { User, UserCreationParams } from '~core/models/auth.models';
import { Pagination, RequestParams } from '~core/models/core.models';
import { ApiConstantsService } from '~core/services/api-constants.service';
import { environment } from '~environments/environment';

@Injectable()
export class UserService {
  private _httpClient = inject(HttpClient);
  private _globalFacade = inject(GlobalFacade);
  protected _authFacade = inject(AuthFacade);
  private _apiConstantsService = inject(ApiConstantsService);

  create(data: UserCreationParams, otp?: string): Observable<User> {
    return this._httpClient
      .post<User>(
        this._apiConstantsService.usersUrl,
        { ...data, redirectUrl: `${environment.redirectUrl}/connexion` },
        {
          headers: {
            authorization: `Otp ${otp}`
          }
        }
      )
      .pipe(
        tap({
          error: error => this._globalFacade.handleFormViolations(error)
        })
      );
  }

  listUser(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<User>> {
    return this._httpClient.get<Pagination<User>>(
      this._apiConstantsService.usersUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  readUser(userId: string): Observable<User> {
    return this._httpClient.get<User>(
      `${this._apiConstantsService.usersUrl}/${userId}`
    );
  }

  inviteUserToOrganization(data: UserCreationParams): Observable<User> {
    return this._httpClient.post<User>(this._apiConstantsService.usersUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  read(userId: string): Observable<User> {
    return this._httpClient.get<User>(
      `${this._apiConstantsService.usersUrl}/${userId}`
    );
  }

  list(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<User>> {
    return this._httpClient.get<Pagination<User>>(
      this._apiConstantsService.usersUrl,
      {
        params: {
          ...params,
          // id: `neq(${this._authFacade.currentUser?.id})`, // exclude current user
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  update(id: string, data: Partial<UserCreationParams>): Observable<User> {
    return this._httpClient.patch<User>(
      `${this._apiConstantsService.usersUrl}/${id}`,
      {
        ...data,
        useStateFormViolationHandler: true
      }
    );
  }

  delete(userId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(
      `${this._apiConstantsService.usersUrl}/${userId}`
    );
  }
}
